export default "__VITE_ASSET__ChSxWnpw__"